import React from 'react';
import DecisionContainer from './decision-container';
var RegistrationContainer = require('./registration');
var Menu = require('../ui_elements/menu').Menu;
var MenuMixin = require('../ui_elements/menu').MenuMixin;
import Dispatcher from '../../dispatcher';

// SSO page (decision/merge/register)
class SSO extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
    this._setRegistrationEmail = this._setRegistrationEmail.bind(this);
    this._handleMergeResponse = this._handleMergeResponse.bind(this);
    this._mergeAccount = this._mergeAccount.bind(this);
    this._setInfo = this._setInfo.bind(this);
    this._resetEmail = this._resetEmail.bind(this);
  }

  _setRegistrationEmail(email){
    this.setState({registrationEmail: email});
  }

  _handleMergeResponse(response){
    Fraction.Helpers.removeLoader('body');
    Fraction.Helpers.removeLoader('header');
    if (response.isSuccess()){
      Fraction.Helpers.setItem('_lastOnboarding', Fraction.User.email.hashMe());
      Fraction.User.needsBookListUpdate = true;
      Fraction.User.needsPasswordUpdate = response.data.needsPasswordUpdate;
      Fraction.User.ssoOnly = false;
      Fraction.User.eulaAccepted = response.data.eulaAccepted;
      Dispatcher.emit(Dispatcher.USER_CHANGE, Fraction.User);
      Fraction.Helpers.redirectMe();
      Fraction.Reporter.gaEvent("sso/merge-account");
    } else {
      this.setState({ signinerror: true });
    }
    // what happens when you're not authorized?
  }

  _mergeAccount(options){
    // merge the accounts!
    Fraction.Helpers.addLoader('body',"top:44px;",i18n.t("sso.finishing-account"));
    Fraction.Helpers.addLoader('header',"top:0px;height:44px;bottom:auto;background:#40404c;opacity:0.5;");
    Jigsaw.User.mergeAccount(options, function(response){
      this._handleMergeResponse(response);
    }.bind(this));
  }

  _setInfo(options){
    // merge the accounts!
    Fraction.Helpers.addLoader('body',"top:44px;",i18n.t("sso.finishing-account"));
    Fraction.Helpers.addLoader('header',"top:0px;height:44px;bottom:auto;background:#40404c;opacity:0.5;");
    Fraction.Helpers.setUserInfo(options, function(response){
      this._handleMergeResponse(response);
    }.bind(this));
  }


  _resetEmail() {
    this.setState({registrationEmail: false});
    Fraction.Router.setRoute('user/sso', true);
  }

  render(){
    return (
      <div>
        {this.state.registrationEmail ?
          <RegistrationContainer {...this.props} setInfo={this._setInfo} mergeAccount={this._mergeAccount} resetEmailCallback={this._resetEmail} nextDisabled={false} email={this.state.registrationEmail} emailStatus="available" viaSSO={true} /> :
          <DecisionContainer {...this.props} mergeAccount={this._mergeAccount} setRegistrationEmail={this._setRegistrationEmail} signinerror={this.state.signinerror} />
        }
      </div>
    );
  }

}

module.exports = SSO;
